const watchOverview = [
  {
      "city": "Abu Dhabi",
      "country": "UAE",
      "millionaires": 22700,
      "centiMillionaires": 68,
      "billionaires": 5,
      "centiGrowth": 75
  },
  {
      "city": "Athens",
      "country": "Greece",
      "millionaires": 22600,
      "centiMillionaires": 42,
      "billionaires": 3,
      "centiGrowth": 15
  },
  {
      "city": "Lisbon",
      "country": "Portugal",
      "millionaires": 21800,
      "centiMillionaires": 37,
      "billionaires": 3,
      "centiGrowth": 33
  },
  {
      "city": "Riyadh",
      "country": "Saudi Arabia",
      "millionaires": 18200,
      "centiMillionaires": 67,
      "billionaires": 8,
      "centiGrowth": 40
  },
  {
      "city": "Luxembourg City",
      "country": "Luxembourg",
      "millionaires": 18000,
      "centiMillionaires": 82,
      "billionaires": 6,
      "centiGrowth": 32
  },
  {
      "city": "Monaco",
      "country": "Monaco",
      "millionaires": 15600,
      "centiMillionaires": 185,
      "billionaires": 25,
      "centiGrowth": 68
  },
  {
      "city": "Calgary",
      "country": "Canada",
      "millionaires": 15000,
      "centiMillionaires": 22,
      "billionaires": 4,
      "centiGrowth": 44
  },
  {
      "city": "Scottsdale",
      "country": "USA",
      "millionaires": 14500,
      "centiMillionaires": 63,
      "billionaires": 5,
      "centiGrowth": 102
  },
  {
      "city": "Bengaluru",
      "country": "India",
      "millionaires": 13200,
      "centiMillionaires": 42,
      "billionaires": 8,
      "centiGrowth": 120
  },
  {
      "city": "Greenwich & Darien",
      "country": "USA",
      "millionaires": 12500,
      "centiMillionaires": 120,
      "billionaires": 10,
      "centiGrowth": 84
  },
  {
      "city": "Palm Beach & West Palm Beach",
      "country": "USA",
      "millionaires": 10200,
      "centiMillionaires": 69,
      "billionaires": 9,
      "centiGrowth": 93
  },
  {
      "city": "Jeddah",
      "country": "Saudi Arabia",
      "millionaires": 7500,
      "centiMillionaires": 32,
      "billionaires": 8,
      "centiGrowth": 32
  },
  {
      "city": "Cape Town",
      "country": "South Africa",
      "millionaires": 7400,
      "centiMillionaires": 28,
      "billionaires": 1,
      "centiGrowth": 20
  },
  {
      "city": "Ho Chi Minh City",
      "country": "Vietnam",
      "millionaires": 7200,
      "centiMillionaires": 24,
      "billionaires": 3,
      "centiGrowth": 100
  },
  {
      "city": "Nairobi",
      "country": "Kenya",
      "millionaires": 4400,
      "centiMillionaires": 10,
      "billionaires": "-",
      "centiGrowth": 25
  }
];



export {watchOverview};